module.exports = __webpack_public_path__ + "img/ad-support-md.d32dd6dc.jpg";